import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { WindowService } from '@shared/window';

@Component({
    selector: 'app-certificates',
    templateUrl: './certificates.component.html',
    styleUrls: ['./certificates.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslatePipe],
})
export class CertificatesComponent implements OnInit {
    private windowService = inject(WindowService);
    private translationService = inject(TranslateService);

    currentLang = this.translationService.currentLang;

    ngOnInit() {
        this.windowService.scrollTop();
    }
}
